<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div class="payWallBtn">
    <svg class="paywallGlyph" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
         xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs></defs>
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Real-Madrid-Pass---Home-lock02" transform="translate(-240.000000, -40.000000)">
          <g id="Group" transform="translate(240.000000, 40.000000)">
            <polygon id="Shape" points="0 0 24 0 24 24 0 24"></polygon>
            <path id="#paywallGlyphTicket"
              d="M13.52568,6.6876 L12.66336,7.54968 L13.91928,8.80536 L14.78136,7.94328 L13.52568,6.6876 Z M16.04448,9.20664 L15.18264,10.06848 L16.43832,11.32416 L17.3004,10.46208 L16.04448,9.20664 Z M15.22296,0 L17.84784,2.62464 C16.99632,3.6072 17.0376,5.0952 17.97144,6.02904 C18.90504,6.96264 20.39304,7.00368 21.37584,6.1524 L24,8.77704 L19.80768,12.9696 L18.56352,11.7252 L17.7012,12.58728 L18.94536,13.83144 L8.77704,24 L6.12912,21.35184 C6.80664,20.37696 6.71112,19.02696 5.84232,18.1584 C4.97256,17.28888 3.62304,17.19336 2.64816,17.87112 L0,15.22296 L10.16856,5.05464 L11.40072,6.2868 L12.26256,5.42472 L11.0304,4.19256 L15.22296,0 Z"
              :fill="colors.mainActionColor"
              fill-rule="nonzero"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>
<script lang="js">
import { mapState } from 'vuex';

export default {
  name: 'PaywallGlyph',
  computed: {
    ...mapState(['colors']),
  },
};
</script>
